<template>
    <v-expand-transition>
        <div v-if="!readOnly && suggestedOpeningDays !== null && suggestedOpeningDays.length">
            <div class="suggestion-container">
                <div class="d-flex">
                    <v-icon class="mr-2" color="warning">info</v-icon>
                    <div class="mt-auto mb-auto">
                        <b style="font-size: 18px">Différence détectée</b>
                    </div>
                </div>

                <div class="mt-3">
                    Des nouveaux horaires ont été détectés sur Google :

                    <div class="mt-2 ml-2">
                        <div v-for="day in suggestedOpeningDays"
                             class="d-flex"
                        >
                            <div style="width: 90px">{{ daysOfWeek[day.day_of_week] }}</div>
                            <div class="mr-5">–</div>
                            <div v-if="day.opening_hours.length === 0">Fermé</div>
                            <div v-else-if="day.opening_hours[0].open !== null">
                                <div class="d-flex">
                                    <div>{{ day.opening_hours[0].open }} - {{ day.opening_hours[0].close }}</div>

                                    <div v-if="day.opening_hours.length === 2" class="ml-5 mr-5">/</div>
                                    <div v-if="day.opening_hours.length === 2">
                                        {{ day.opening_hours[1].open }} - {{ day.opening_hours[1].close }}
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="!day.closed">Ouvert</div>
                            <div v-else>Non renseigné</div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center flex-wrap mt-4 mb-2" v-if="!readOnly">
                    <v-btn
                      class="text-none mr-5"
                      color="warning"
                      large
                      v-if="provider.opening_periods.length === 0"
                      style="border-radius: 25px; border-width: 2px; font-weight: bold"
                      outlined
                      @click="acceptSuggestion()"
                    >
                        Ajouter une période
                    </v-btn>

                    <v-btn
                      class="text-none mr-5"
                      color="warning"
                      large
                      v-else
                      style="border-radius: 25px; border-width: 2px; font-weight: bold"
                      outlined
                      @click="openSuggestionModal()"
                    >
                        Modifier la période en cours
                    </v-btn>

                    <v-btn
                      class="text-none ml-5"
                      text
                      color="#ffa533"
                      style="font-size: 16px"
                      @click="setEmptySuggestedOpeningDays()"
                    >
                        Ignorer
                    </v-btn>
                </div>
            </div>
        </div>
    </v-expand-transition>
</template>

<script>
import { mapState, mapMutations } from "vuex"

export default {
    name: "OpeningPeriodSuggestion",
    data() {
        return {
            daysOfWeek: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
        }
    },
    computed: {
        ...mapState("web_form", [
            "provider",
            "suggestedOpeningDays",
            "readOnly",
        ]),
    },
    methods: {
        ...mapMutations("web_form", ["setEmptySuggestedOpeningDays", "setCurrentOpeningPeriod", "setAddOpeningPeriodDialog"]),
        openSuggestionModal() {
            const firstPeriod = this.provider.opening_periods[0]

            let period = {
                description: null,
                valid_from: firstPeriod.valid_from,
                valid_through: firstPeriod.valid_through,
                opening_days: this.suggestedOpeningDays,
                h24: false,
                suggestion: true,
                uid: firstPeriod.uid,
            }

            this.setCurrentOpeningPeriod(period)
            this.setAddOpeningPeriodDialog(true)
        },
        acceptSuggestion() {
            let period = {
                description: null,
                valid_from: null,
                valid_through: null,
                opening_days: this.suggestedOpeningDays,
                h24: false,
                suggestion: true,
                uid: Math.random().toString(36).substr(2, 16),
            }

            this.setCurrentOpeningPeriod(period)
            this.setAddOpeningPeriodDialog(true)
        },
    },
}
</script>

